<div id="carousel"
     class="carousel carousel-dark slide shadow overflow-hidden rounded-3">
  <div class="m-2 position-absolute z-3 top-0 end-0">
    <nz-toggle-ad-like-button
      [adId]="adDetails.adId"
      (onLike)="onLike($event)"
      (onDislike)="onDislike()"
      [userAdLikeId]="adDetails.userAdLikeId"/>
  </div>
  <div class="carousel-indicators">
    @if (imageUrls.length > 1) {
      @for (imageUrl of imageUrls; track imageUrl; let index = $index, first = $first) {
        <button
          type="button"
          data-bs-target="#carousel"
          [class.active]="first"
          [attr.aria-current]="first"
          [attr.data-bs-slide-to]="index"
          [attr.aria-label]="'Slide ' + index + 1"
          (click)="currentImageIndex = index">
        </button>
      }
    }
  </div>
  <div class="carousel-inner rounded-3">
    @for (imageUrl of imageUrls; track imageUrl; let index = $index, first = $first) {
      <div
        [class.active]="first"
        (click)="onPreviewImages()"
        class="carousel-item border rounded-3 overflow-hidden">
        <nz-image
          [imageUrl]="imageUrl"
          backgroundClass="bg-light"/>
      </div>
    }
  </div>
  @if (imageUrls.length > 1) {
    <button
      type="button"
      data-bs-slide="prev"
      data-bs-target="#carousel"
      class="carousel-control-prev"
      (click)="onSlideImage('prev')">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      type="button"
      data-bs-slide="next"
      data-bs-target="#carousel"
      class="carousel-control-next"
      (click)="onSlideImage('next')">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  }
</div>
